module.exports = "<main>\n  <router-outlet></router-outlet>\n  <app-text-message></app-text-message>\n</main>\n"